import React from 'react';
import propTypes from 'prop-types';
export const PeopleIcon = ({ size, color, variant }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      fill={color}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={sizeInPixel}
      height={sizeInPixel}
      viewBox="0 0 256 226"
      enableBackground="new 0 0 256 226"
      xmlSpace="preserve"
    >
      <path
        d="M29.398,20.769c0-10.121,8.205-18.325,18.325-18.325c10.121,0,18.325,8.204,18.325,18.325
   c0,10.121-8.205,18.325-18.325,18.325C37.603,39.095,29.398,30.89,29.398,20.769z M70.479,43.928H24.565
   c-12.485,0-22.957,10.27-22.554,22.957v56.386c0,4.43,3.423,8.055,8.055,8.055c4.43,0,8.055-3.625,8.055-8.055V71.516
   c0-1.208,1.007-2.215,2.215-2.215c1.208,0,2.215,1.007,2.215,2.215v139.554c0,6.847,5.034,12.485,11.479,12.485
   c6.444,0,11.478-5.639,11.478-12.485v-79.544c0-1.208,1.007-2.215,2.215-2.215c1.208,0,2.215,1.007,2.215,2.215v79.544
   c0,6.847,5.034,12.485,11.479,12.485s11.479-5.639,11.479-12.485V71.516c0-1.208,1.007-2.215,2.215-2.215s2.215,1.007,2.215,2.215
   v51.553c0,4.43,3.423,8.055,8.055,8.055c4.43,0,8.055-3.625,8.055-8.055V66.885C93.436,54.198,83.166,43.928,70.479,43.928z
    M125.22,18.025c0-8.605,6.976-15.581,15.581-15.581c8.605,0,15.581,6.976,15.581,15.581c0,8.605-6.976,15.581-15.581,15.581
   C132.196,33.606,125.22,26.63,125.22,18.025z M160.149,37.715h-39.038c-10.616,0-19.519,8.732-19.176,19.519v47.941
   c0,3.767,2.911,6.849,6.849,6.849c3.767,0,6.849-3.082,6.849-6.849V61.172c0-1.027,0.856-1.883,1.883-1.883
   c1.027,0,1.883,0.856,1.883,1.883v118.654c0,5.821,4.28,10.615,9.759,10.615c5.479,0,9.759-4.794,9.759-10.615v-67.631
   c0-1.027,0.856-1.883,1.883-1.883s1.883,0.856,1.883,1.883v67.631c0,5.821,4.281,10.615,9.759,10.615s9.759-4.794,9.759-10.615
   V61.172c0-1.027,0.856-1.883,1.883-1.883s1.883,0.856,1.883,1.883v43.832c0,3.767,2.911,6.849,6.849,6.849
   c3.767,0,6.849-3.082,6.849-6.849v-47.77C179.667,46.447,170.935,37.715,160.149,37.715z M209.143,15.281
   c0-7.089,5.747-12.836,12.837-12.836c7.089,0,12.836,5.747,12.836,12.836c0,7.089-5.747,12.836-12.836,12.836
   C214.89,28.117,209.143,22.37,209.143,15.281z M237.919,31.502h-32.162c-8.746,0-16.081,7.194-15.799,16.081V87.08
   c0,3.103,2.398,5.642,5.642,5.642c3.103,0,5.642-2.539,5.642-5.642V50.828c0-0.846,0.705-1.552,1.552-1.552
   c0.846,0,1.552,0.705,1.552,1.552v97.755c0,4.796,3.526,8.746,8.04,8.746c4.514,0,8.04-3.95,8.04-8.746V92.864
   c0-0.846,0.705-1.552,1.552-1.552c0.846,0,1.552,0.705,1.552,1.552v55.719c0,4.796,3.527,8.746,8.04,8.746
   c4.514,0,8.04-3.95,8.04-8.746V50.828c0-0.846,0.705-1.552,1.552-1.552s1.552,0.705,1.552,1.552v36.111
   c0,3.103,2.398,5.642,5.642,5.642c3.103,0,5.642-2.539,5.642-5.642V47.583C254,38.696,246.806,31.502,237.919,31.502z"
      />
    </svg>
  );
};
PeopleIcon.prototype = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
};
PeopleIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
};
